import R from "./_Stack.js";
import h from "./_baseIsEqual.js";
var M = R, O = h, p = 1, w = 2;
function C(r, I, e, i) {
  var f = e.length, v = f, u = !i;
  if (r == null)
    return !v;
  for (r = Object(r); f--; ) {
    var n = e[f];
    if (u && n[2] ? n[1] !== r[n[0]] : !(n[0] in r))
      return !1;
  }
  for (; ++f < v; ) {
    n = e[f];
    var l = n[0], s = r[l], _ = n[1];
    if (u && n[2]) {
      if (s === void 0 && !(l in r))
        return !1;
    } else {
      var A = new M();
      if (i)
        var E = i(s, _, l, r, I, A);
      if (!(E === void 0 ? O(_, s, p | w, i, A) : E))
        return !1;
    }
  }
  return !0;
}
var g = C;
export {
  g as default
};
//# sourceMappingURL=_baseIsMatch.js.map
